// extracted by mini-css-extract-plugin
module.exports =  {"ViewCount":"UJUMyh_F6cdyeKoKSYu2"};